import { render } from "./print-stock-transfer.vue?vue&type=template&id=ea65b9e4&scoped=true"
import script from "./print-stock-transfer.vue?vue&type=script&lang=js"
export * from "./print-stock-transfer.vue?vue&type=script&lang=js"

import "./print-stock-transfer.vue?vue&type=style&index=0&id=ea65b9e4&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea65b9e4"]])

export default __exports__